import axios from "axios";
import { dashboardUserApi, getUsersListUrl, userFarmDataApi, userSearchApiUrl, userSegerationApi, userPointsApi, userPointsHistoryApi } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const postFarmer = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(userSearchApiUrl, data, config);
    return response;
};

export const patchFarmer = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(userSearchApiUrl, data, config);
    return response;
};


export const getUsers = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(getUsersListUrl + "?page_size=100&" + query ?? "", config);

    return response;
};


export const getUserDetail = async ({ userId, endPoint }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(dashboardUserApi + userId + endPoint, config);
    return response;
};

export const getUserPoints = async ({ userId }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(userPointsApi + userId, config);
    return response;
};

export const postUserSegrigation = async ({ data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(userSegerationApi, data, config);
    return response;
};

export const patchUserSegrigation = async ({ data, id }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(userSegerationApi + id + "/", data, config);
    return response;
};

export const deleteFarm = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.delete(userFarmDataApi + id + "/", config);
    return response;
};

export const postUserPoints = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(userPointsHistoryApi, data, config);
    return response;
};